




























































import Vue from 'vue'
import SphereConnection from '@/components/SphereConnection.vue'
export default Vue.extend({
    components: { SphereConnection },
    data() {
        return {
            toolbar: {
                title: 'Sphere',
                left: [
                    {
                        title: 'Back',
                        icon: 'mdi-chevron-left',
                        back: '/settings',
                        tooltip: 'Back',
                        permission: 0,
                        feature: null
                    }
                ],
                right: []
            }
        }
    }
})
